<ng-content select="tyt-vertical-carousel-item"></ng-content>